import { render, staticRenderFns } from "./HrDocumentReviewDetailDialog.vue?vue&type=template&id=76b81208&scoped=true&"
import script from "./HrDocumentReviewDetailDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentReviewDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./HrDocumentReviewDetailDialog.vue?vue&type=style&index=0&id=76b81208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b81208",
  null
  
)

export default component.exports